export default {
  email: '',
  subscribe: false,
}
